import { useState } from "react";

import Timer from "../timer/Timer.js";
import ReCAPTCHA from "react-google-recaptcha";
import TokenCarousel from "../token-carousel/TokenCarousel.js";

import "./ProductModal.css";

function ProductModal({
  product,
  isActive,
  toggle,
  status,
  reservedTimer,
  queueTimer,
  expireReservation,
  reserveProduct,
  setCaptchaUserResponseToken,
  checkIfAddrWhitelisted,
}) {
  if (status === null || status === "LOADING") {
    return <Loader product={product} isActive={isActive} toggle={toggle} />;
  } else if (status === "WHITELIST") {
    return (
      <WhitelistModal
        isActive={isActive}
        toggle={toggle}
        checkIfAddrWlst={checkIfAddrWhitelisted}
        status={status}
      />
    );
  } else if (status === "CAPTCHA") {
    return (
      <PlaceholderLoadingModal
        reserveProduct={reserveProduct}
        product={product}
        isActive={isActive}
        toggle={toggle}
        status={status}
        setCaptchaUserResponseToken={setCaptchaUserResponseToken}
      />
    );
  }

  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value).then(
      function () {},
      function () {
        console.warn(
          "Copy failed - are you accessing via a secure connection?"
        );
      }
    );
  };

  const productData = product.data || {};
  const tokens = productData.tokens || null;

  const { address, price_ada, error_code, error_message } =
    productData.payload || {};

  const qrAddress = `https://chart.googleapis.com/chart?chs=300x300&cht=qr&choe=UTF-8&chl=web+cardano:${address}?amount=${price_ada}`;

  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {product.name}{" "}
            {product.bundleName ? ` | ${product.bundleName}` : ""}
          </p>
        </header>
        <section className="modal-card-body">
          {status === "SERVER_ERROR" && (
            <div id="server-error" className="nft-modal-section">
              Server was unable to process the request. Please wait and try
              again later.
            </div>
          )}

          {status === "SOLD_OUT" && (
            <div id="server-error" className="nft-modal-section">
              All tokens are reserved or sold Out! Refresh the page to see if
              any reservations have expired.
            </div>
          )}

          {status === "COOLDOWN" && error_code === 1 && (
            <div id="nft-reserve-error" className="nft-modal-section">
              <p id="reserve-error-message">
                {error_message || "Unable to Reserve Token. Please try again"}
              </p>
            </div>
          )}

          {status === "EXPIRED" && (
            <div id="nft-expired" className="nft-modal-section">
              <p>Reservation expired. Close this pop-up and try again!</p>
            </div>
          )}

          {status === "ADDR_NOT_ALLOWED" && (
            <div id="addr-not-allowed" className="nft-modal-section">
              Sorry you are not on the list. Come back for the public sale on 2021-12-20 at 11:00 AM EST!
            </div>
          )}

          {status === "QUEUED" && (
            <div id="nft-queued" className="nft-modal-section">
              <p className="has-text-centered">
                Your reservation will be available in:
              </p>
              <Timer
                timerType="queue"
                duration={queueTimer}
                expiryBuffer={10}
                expireReservation={() =>
                  console.log("Fetching your reservation...")
                }
              />
              <div className="columns">
                <div className="column">
                  <div className="column notification is-warning">
                    <p>
                      Please <b>do not</b> close this popup! You will lose your
                      position in the queue.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {status === "RESERVED" && !error_code && (
            <div id="nft-reserved" className="nft-modal-section">
              <div className="columns is-vcentered">
                <div className="column is-half">
                  <figure>
                    <img
                      id="cardano-url-qr"
                      width="300px"
                      height="300px"
                      src={qrAddress}
                      alt="Address and Ada QR"
                    />
                  </figure>
                </div>
                <div className="column is-half">
                  <Timer
                    duration={reservedTimer}
                    expireReservation={expireReservation}
                  />
                  <label className="label">Send to:</label>
                  <div className="field has-addons">
                    <div className="control is-expanded">
                      <input
                        id="send-to-address"
                        className="input"
                        value={address}
                        readOnly
                      />
                    </div>
                    <div className="control">
                      <button
                        id="address-copy"
                        className="button"
                        onClick={() => copyToClipboard(address)}
                      >
                        Copy
                      </button>
                    </div>
                  </div>

                  <label className="label">Price:</label>
                  <div className="field has-addons">
                    <div className="control  is-expanded">
                      <input
                        id="price-ada"
                        className="input"
                        value={price_ada}
                        readOnly
                      />
                    </div>
                    <div className="control">
                      <button
                        id="price-copy"
                        className="button"
                        onClick={() => copyToClipboard(price_ada)}
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="column notification">
                    <p>
                      Please send exactly the amount of ADA shown above to the
                      address displayed. The time remaining in your reservation
                      is shown above.
                    </p>
                  </div>
                  <div className="column notification">
                    <p>
                      Please keep this window open until your transaction has
                      been successfully processed.
                    </p>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="notification is-warning">
                    <p>
                      <strong>
                        Warning! Do not send ADA from an exchange!
                      </strong>
                    </p>
                    <p>
                      You must use a Cardano Shelley-Era wallet like Daedalus,
                      Yoroi, or ADALite.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {status === "SUCCESS" && <TokenCarousel tokens={tokens} />}
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          {status !== "SUCCESS" && (
            <button
              className="button close"
              onClick={() => {
                toggle();
                expireReservation();
              }}
            >
              Close
            </button>
          )}
          {status === "SUCCESS" && (
            <button
              id="nft-success-regen-btn"
              className="button secondary-btn"
              onClick={() => {
                toggle();
                expireReservation();
              }}
            >
              Get more!
            </button>
          )}
        </footer>
      </div>
    </div>
  );
}

function Loader({ product, isActive, toggle }) {
  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {product.name}{" "}
            {product.bundleName ? ` | ${product.bundleName}` : ""}
          </p>
        </header>
        <section className="modal-card-body">
          <div id="nft-loading" className="nft-modal-section">
            <div
              className="columns has-text-centered is-centered"
              style={{ padding: "20px", overflow: "hidden" }}
            >
              <div
                class="loader is-loading"
                style={{
                  height: "50px",
                  width: "50px",
                }}
              ></div>
            </div>
          </div>
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          <button className="button close" onClick={toggle}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}

function PlaceholderLoadingModal({
  product,
  isActive,
  toggle,
  status,
  reserveProduct,
  setCaptchaUserResponseToken,
}) {
  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {product.name}{" "}
            {product.bundleName ? ` | ${product.bundleName}` : ""}
          </p>
        </header>
        <section className="modal-card-body">
          <div id="nft-loading" className="nft-modal-section">
            <div className="columns has-text-centered is-centered">
              <div id="captcha-container" className="column">
                {status === "CAPTCHA" && (
                  <ReCAPTCHA
                    sitekey="6Lcebq0dAAAAAIT9nwpnSbK4lA8F0E9FcjrZGhCG"
                    onChange={(userToken) => {
                      setCaptchaUserResponseToken(userToken);
                      reserveProduct(product);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          <button className="button close" onClick={toggle}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}

function WhitelistModal({ checkIfAddrWlst, isActive, toggle, status }) {
  const [wlstVal, setWlstVal] = useState("");

  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Verify if address is whitelisted</p>
        </header>
        <section className="modal-card-body">
          <div id="nft-loading" className="nft-modal-section">
            <div className="columns has-text-centered is-centered">
              <div className="column is-8">
                <p>Minting is only for whitelisted addresses right now. Enter your address to see if you qualify!</p>
              </div>
            </div>
            <div className="columns has-text-centered is-centered">

              {status === "WHITELIST" && (
                <div className="field has-addons">
                  <div className="control is-expanded">
                    <input
                      id="wlst-address"
                      className="input"
                      value={wlstVal}
                      onChange={(e) => setWlstVal(e.target.value)}
                    />
                  </div>
                  <div className="control">
                    <button
                      id="sbmt-addr"
                      className="button"
                      onClick={() => checkIfAddrWlst(wlstVal)}
                    >
                      Check
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          <button className="button close" onClick={toggle}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}
export default ProductModal;
